"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimestampRestoreStrategy = void 0;
var RestoreStrategy_1 = require("./RestoreStrategy");
var MessageIdRestoreStrategyBuilder = /** @class */ (function () {
    function MessageIdRestoreStrategyBuilder() {
    }
    MessageIdRestoreStrategyBuilder.prototype.withT = function (t) {
        this.t = t;
        return this;
    };
    MessageIdRestoreStrategyBuilder.prototype.build = function () {
        return new TimestampRestoreStrategy(this.t);
    };
    return MessageIdRestoreStrategyBuilder;
}());
exports.default = MessageIdRestoreStrategyBuilder;
var TimestampRestoreStrategy = /** @class */ (function (_super) {
    __extends(TimestampRestoreStrategy, _super);
    function TimestampRestoreStrategy(t) {
        var _this = _super.call(this, 'Timestamp') || this;
        _this.t = t;
        return _this;
    }
    return TimestampRestoreStrategy;
}(RestoreStrategy_1.default));
exports.TimestampRestoreStrategy = TimestampRestoreStrategy;
//# sourceMappingURL=TimestampRestoreStrategyBuilder.js.map